import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FirebaseAuthProvider } from '@react-firebase/auth';
import { InitializeAppArgs } from '@react-firebase/auth/dist/types';

// @ts-ignore
const config: InitializeAppArgs = {
  apiKey: "AIzaSyBLYNfZiK4nQZEFYv8knm3CR6Fn12wv2P4",
  authDomain: "diggy-app-68b48.firebaseapp.com",
  projectId: "diggy-app-68b48",
  storageBucket: "diggy-app-68b48.appspot.com",
  messagingSenderId: "118408581576",
  appId: "1:118408581576:web:7cf869bd8940d9020d30fd",
  measurementId: "G-MNM32CVPRX",
  firebase
};

ReactDOM.render(
  <React.StrictMode>
    <FirebaseAuthProvider {...config}>
      <App />
    </FirebaseAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
